import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const INITIAL_STATE = {
  restaurantPreference: {
    bookmark: {
      data: [],
      offset: 0,
      limit: 10,
      isLoading: false,
      hasMore: true
    },
    dislike: {
      isLoading: false,
      data: []
    },
    viewHistory: {
      data: [],
      offset: 0,
      limit: 10,
      isLoading: false,
      hasMore: true
    }
  },
  productPreference: {}
};

export default function preferenceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Bookmark Restaurant
    case actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);
      restaurantPreference.bookmark.offset = action.data.offset;
      restaurantPreference.bookmark.limit = action.data.limit;
      restaurantPreference.bookmark.isLoading = true;
      restaurantPreference.bookmark.hasMore = false;

      if (restaurantPreference.bookmark.offset === 0) {
        restaurantPreference.bookmark.data = [];
      }

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST_SUCCESS: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);
      restaurantPreference.bookmark.data = [
        ...restaurantPreference.bookmark.data,
        ...action.data
      ];
      restaurantPreference.bookmark.isLoading = false;
      restaurantPreference.bookmark.hasMore = true;

      if (action.data.length < restaurantPreference.bookmark.limit) {
        restaurantPreference.bookmark.hasMore = false;
      }

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.LOAD_BOOKMARK_RESTAURANT_LIST_FAIL: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);
      restaurantPreference.bookmark.isLoading = false;
      restaurantPreference.bookmark.hasMore = false;

      return {
        ...state,
        restaurantPreference
      };
    }
    // Don't Show Restaurant
    case actionTypes.LOAD_DISLIKE_RESTAURANT_LIST: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);

      restaurantPreference.dislike.offset = action.data.offset;
      restaurantPreference.dislike.limit = action.data.limit;
      restaurantPreference.dislike.isLoading = true;
      restaurantPreference.dislike.hasMore = false;

      if (restaurantPreference.dislike.offset === 0) {
        restaurantPreference.dislike.data = [];
      }

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.LOAD_DISLIKE_RESTAURANT_LIST_SUCCESS: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);

      restaurantPreference.dislike.data = [
        ...restaurantPreference.dislike.data,
        ...action.data
      ];
      restaurantPreference.dislike.isLoading = false;
      restaurantPreference.dislike.hasMore = true;

      if (action.data.length < restaurantPreference.dislike.limit) {
        restaurantPreference.dislike.hasMore = false;
      }

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.LOAD_DISLIKE_RESTAURANT_LIST_FAIL: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);

      restaurantPreference.dislike.isLoading = false;
      restaurantPreference.dislike.hasMore = false;

      return {
        ...state,
        restaurantPreference
      };
    }
    // View History Restaurant
    case actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);

      restaurantPreference.viewHistory.offset = action.data.offset;
      restaurantPreference.viewHistory.limit = action.data.limit;
      restaurantPreference.viewHistory.isLoading = true;
      restaurantPreference.viewHistory.hasMore = false;

      if (restaurantPreference.viewHistory.offset === 0) {
        restaurantPreference.viewHistory.data = [];
      }

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST_SUCCESS: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);

      restaurantPreference.viewHistory.data = [
        ...restaurantPreference.viewHistory.data,
        ...action.data
      ];
      restaurantPreference.viewHistory.isLoading = false;
      restaurantPreference.viewHistory.hasMore = true;

      if (action.data.length < restaurantPreference.viewHistory.limit) {
        restaurantPreference.viewHistory.hasMore = false;
      }

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.LOAD_VIEW_HISTORY_RESTAURANT_LIST_FAIL: {
      let restaurantPreference = cloneDeep(state.restaurantPreference);

      restaurantPreference.viewHistory.isLoading = false;
      restaurantPreference.viewHistory.hasMore = false;

      return {
        ...state,
        restaurantPreference
      };
    }
    case actionTypes.SET_PRODUCT_PREFERENCE:
      return {
        ...state,
        productPreference: {}
      };
    case actionTypes.SET_PRODUCT_PREFERENCE_SUCCESS:
      return {
        ...state,
        productPreference: {
          data: action.data,
          success: true
        }
      };
    default:
      return state;
  }
}
